import { gql } from '@apollo/client';



export const CREATE_ACREDITACION_PROFILE_ATTENTION_PERSONAL= gql`
mutation ($profile_uuid:ID!, $input:inputProfileAsistPersonalAttention!){
    createAcreditationProfilePersonalAttention(profile_uuid:$profile_uuid, input:$input){
        id,
        acreditaciones_profile_uuid,
        
        razon,
        razon_cual,
  
        forma,
        contacto_num,
  
        created_at,
        updated_at,
        deleted_at
    }
  }
`;